import { Tag } from "antd";
import React from "react";

export default function CrmBadge({ name }) {
  let badgeColor = {
    joined: "green",
    unpaid: "",
    new: "#387F39",
    regular: "#134B70",
    disconnected: "red",
  };

  return (
    <Tag
      color={badgeColor[name] || "black"}
      style={{
        textTransform: "capitalize",
      }}
    >
      {name}
    </Tag>
  );
}
